import {removeUndefinedValues} from "~/util/misc";
import {convertMatchRequestToApi} from "~/util/convert-to-api";
import CandidateMatch from "~/entities/CandidateMatch";
import JobMatch from "~/entities/JobMatch";

export default function addMatchingCalls(Client) {
    Client.prototype.matchProfileToCandidatesV1 = function({
        candidateIndex,
        index,
        matchRequest,
        from,
        size,
        language,
        sortModeGroup,
        scoreType,
        expansionType,
        matchingStrategy,
        conversionPreProcessor,
        _source,
    }) {
        const theIndex = index || candidateIndex;

        return this.post(
            `/hrmatching/match2candidates/${theIndex}`,
            removeUndefinedValues({
                ...convertMatchRequestToApi(matchRequest, theIndex, language, sortModeGroup),
                from,
                size,
                _source,
                queryParams: {
                    scoreType,
                    expansionType,
                },
                userLanguage: language,
            }),
            removeUndefinedValues({
                strategy: matchingStrategy !== null ? matchingStrategy : undefined,
            })
        ).then(({response}) => {
            const metadata = {
                from: response.from,
                size: response.size,
                count: response.count,
            };

            const matches = response.matches.map(x =>
                convertCandidateApiMatch(conversionPreProcessor, x)
            );

            return {matches, metadata};
        });
    };

    Client.prototype.downloadProfileToCandidates = function({
        candidateIndex,
        matchRequest,
        language,
        sortModeGroup,
        scoreType,
        expansionType,
        matchingStrategy,
        exportType,
        exportSize,
    }) {
        return this.post(
            `/hrmatching/match2candidates/${candidateIndex}/${exportType}`,
            removeUndefinedValues({
                ...convertMatchRequestToApi(matchRequest, candidateIndex, language, sortModeGroup),
                from: 0,
                size: exportSize,
                queryParams: {
                    scoreType,
                    expansionType,
                },
                userLanguage: language,
            }),
            removeUndefinedValues({
                strategy: matchingStrategy !== null ? matchingStrategy : undefined,
            }),
            {},
            true,
            "arraybuffer"
        );
    };

    Client.prototype.matchProfileToJobsV1 = function({
        jobIndex,
        index,
        matchRequest,
        from,
        size,
        language,
        sortModeGroup,
        scoreType,
        expansionType,
        matchingStrategy,
        conversionPreProcessor,
        _source,
    }) {
        const theIndex = index || jobIndex;

        return this.post(
            `/hrmatching/match2jobs/${theIndex}`,
            removeUndefinedValues({
                ...convertMatchRequestToApi(matchRequest, theIndex, language, sortModeGroup),
                from,
                size,
                _source,
                queryParams: {
                    scoreType,
                    expansionType,
                },
                userLanguage: language,
            }),
            removeUndefinedValues({
                strategy: matchingStrategy !== null ? matchingStrategy : undefined,
            })
        ).then(({response}) => {
            const metadata = {
                from: response.from,
                size: response.size,
                count: response.count,
            };

            const matches = response.matches.map(x =>
                convertJobApiMatch(conversionPreProcessor, x)
            );

            return {matches, metadata};
        });
    };

    Client.prototype.matchDetailsForJobToCandidate = function(
        sourceIndex,
        sourceId,
        targetIndex,
        targetId
    ) {
        return this.post("/hrmatching/match2candidates/details", {
            sourceIndex,
            sourceId,
            targetIndex,
            targetId,
        }).then(({response}) => response.matches.map(match => convertCandidateApiMatch(undefined, match)));
    };
}

export function convertCandidateApiMatch(preprocessor, match) {
    if (preprocessor && match.document) {
        match.document = preprocessor(match.document);
    }

    return new CandidateMatch(match);
}

export function convertJobApiMatch(preprocessor, match) {
    if (preprocessor && match.document) {
        match.document = preprocessor(match.document);
    }

    return new JobMatch(match);
}
